import React, { useContext } from 'react';
import { SelectionContext, SelectedInventoryItemContext } from './ControlBar';

const PartDetailTab = () => {
  const { selectedRegion, selectedInterchange } = useContext(SelectionContext);
  const { selectedInventoryItem } = useContext(SelectedInventoryItemContext);
  return (
    <div>
      <div className="control_blk_containers filter_blk mb_15">
        <h3 className="font_16 fw-semi text_black mb_15">Part Detail</h3>
        {selectedInventoryItem ? (
          <table className="w-100 table">
            <thead>
              <tr>
                <th>Field</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>Comments</td><td>{selectedInventoryItem.comments}</td></tr>
              <tr><td>Region</td><td>{selectedInventoryItem.region}</td></tr>
              <tr><td>Interchange Number</td><td>{selectedInventoryItem.interchange_number}</td></tr>
              <tr><td>Mileage</td><td>{selectedInventoryItem.mileage}</td></tr>
              <tr><td>Part Price</td><td>{selectedInventoryItem.part_price}</td></tr>
              <tr><td>Stock Number</td><td>{selectedInventoryItem.stock_number}</td></tr>
              <tr><td>Unique</td><td>{selectedInventoryItem.unique}</td></tr>
              <tr><td>Model Name</td><td>{selectedInventoryItem.model_name}</td></tr>
              <tr><td>Model Year</td><td>{selectedInventoryItem.model_year}</td></tr>
              <tr><td>Days Instock</td><td>{selectedInventoryItem.days_instock}</td></tr>
              <tr><td>Highest Core Price</td><td>{selectedInventoryItem.highest_core_price}</td></tr>
              <tr><td>keyword_flag</td> <td>{selectedInventoryItem.keyword_flag}</td></tr>
              <tr><td>keyword_flag_flat</td> <td>{selectedInventoryItem.keyword_flag_flat}</td></tr>
              {/* Add more fields as needed */}
            </tbody>
          </table>
        ) : (
          <div>No part selected.</div>
        )}
      </div>
    </div>
  );
};
export default PartDetailTab; 